// ============================================================================
// EMPTY STATE COMPONENT
// Reusable component for displaying empty states
// ============================================================================

import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px 24px',
      textAlign: 'center'
    }}>
      <Icon
        size={48}
        color="#adb5bd"
        strokeWidth={1.5}
        style={{ marginBottom: '16px' }}
      />
      <h3 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#495057',
        margin: '0 0 8px 0'
      }}>
        {title}
      </h3>
      <p style={{
        fontSize: '14px',
        color: '#868e96',
        margin: '0 0 24px 0',
        maxWidth: '400px'
      }}>
        {description}
      </p>
      {action}
    </div>
  );
};
